import Web3Modals from "web3modal";
import Web3 from "web3";
import WalletAbi from './WalletAbi.json'
import BigNumber from 'big-number'

import GoldBuxAbi from "./GoldBuxAbi.json"


import BuxSwapAbi from "./buxSwapAbi.json"

var ContractAddress = "0x86D822e68bC7026c965Cc016d091c5Da4453E4f1"

var GoldBuxContract = "0x0C81dC8473a321C7919cEffbbF75d212e9096cF3"
var BuxSwapContract = "0x94836067243CAdB3461AB2aA699eA208facFa68b"
var BuxSwapVault = "0x4809aafEFe5a4cba12eeCe83411c3A3495FbA3F0"
export const TransferGDBX=async(provider,walletAddress,gdbx)=>
{
    return new Promise(async(resolve,reject)=>
    {
        try
        {
            const web3 = new Web3(provider);
            const contract = new web3.eth.Contract(GoldBuxAbi, GoldBuxContract);
          
           const num = new BigNumber(gdbx * (10**18)).toString()
            const response = await contract.methods.transfer(BuxSwapVault,num).send({from:walletAddress})
            resolve(response)
        }
        catch(e)
        {
            console.log(e)
            reject(e)
        }
       
    })
}

export const ClaimContract=(provider,walletAddress,amount,nonce,expires,signature,tokenAddress)=>
    {
        return new Promise(async(resolve,reject)=>
        {
            try
            {
                const web3 = new Web3(provider);
            const contract = new web3.eth.Contract(BuxSwapAbi, BuxSwapContract);
            const response = await contract.methods.claim(tokenAddress,amount,nonce,expires,signature).send({from:walletAddress})
            resolve(response) 
            }
            catch(e)
            {
                reject(e)
            }
        })
    }